module.exports = __webpack_public_path__ + "static/media/AB_shadow_horisontal.d41c4406.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_shadow_horisontal.png
// module id = 32
// module chunks = 0